import * as React from "react";
import { Icon } from "./Icon";

/**
 * Grackle button (DS Button): always a full pill, 14px Hind Bold. Purple `primary` for the one main
 * action on a view; ink `dark` for Record a video (`record` is the same ink pill with the red live dot
 * when `dot` is set); `now` (butter) for in-the-moment actions like Mark moment or Join call.
 */
export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "record" | "now" | "secondary" | "ghost" | "inverse" | "danger" | "on-accent" | "dark";
  /** sm 30 · md 36 · lg 44 · xl 52 (DS control heights) */
  size?: "sm" | "md" | "lg" | "xl";
  /** Leading Phosphor icon name */
  icon?: string;
  iconFill?: boolean;
  /** Leading record dot (true) or stop square ("stop") */
  dot?: boolean | "stop";
  /** Trailing hotkey hint */
  kbd?: string;
  block?: boolean;
  children?: React.ReactNode;
}

export function Button({
  variant = "primary",
  size = "md",
  icon,
  iconFill,
  dot,
  kbd,
  block,
  className,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  const cls = ["gk-btn", "gk-btn--" + variant, size !== "md" && "gk-btn--" + size, block && "gk-btn--block", className]
    .filter(Boolean)
    .join(" ");
  return (
    <button type="button" className={cls} {...rest}>
      {dot && <span className={"gk-btn__dot" + (dot === "stop" ? " gk-btn__dot--stop" : "")} />}
      {icon && <Icon name={icon} size={size === "sm" ? 18 : 20} fill={iconFill} />}
      {children}
      {kbd && <span className="gk-kbd">{kbd}</span>}
    </button>
  );
}
